import { SvgInterface } from "../../Interfaces/SvgInterface";

export default function ArrowOrange(props: SvgInterface) {
  return (
    <svg width={props.width} height={props.height} viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M7.98811 4.20788L1.63474 14.3674L3.75438 15.6929L10.1078 5.53343L11.8123 12.9286L14.248 12.3671L11.585 0.81365L0.031564 3.47665L0.592988 5.91241L7.98811 4.20788Z" fill="#FF5B50"/>
  </svg>
  )
}